import React, { useState, useEffect } from 'react';
import ApiService from '../../../services/apiService';

const InvoiceViewItemList = ({ onRequisitionData, GrnItemData, currencyPrecision, SelectedPO,
    setOverallDiscount, grandTotal, setVatAmount, vatAmount,
    overallDiscount, setDiscountAmount, discountAmount, setGrandTotal }) => {

    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        qty: '',
        uom: '',
        baseQty: '',
        baseAmount: '',
        unitPrice: '',
        amount: '',
        discount: '',
        vat: '',
        vatAmount: '',
        grnAccountCode: '',
        grnAccountName: '',
        invoiceAccountCode: '',
        invoiceAccountName: '',
        cgsAccountCode: '',
        cgsAccountName: '',
        inventoryAccountCode: '',
        inventoryAccountName: '',
    }]);

    const [overallDiscountAmount, setOverallDiscountAmount] = useState(); // Amount
    const [POActualQty, setPOactualQty] = useState(); // actualQty

    const calculatedTotal = rows.reduce((sum, row) => {
        const amount = parseFloat(row?.amount) || 0;
        const vatAmount = parseFloat(row?.vatAmount) || 0;
        const discount = parseFloat(row?.discount) || 0;
        let final = overallDiscount === 0 ? ((amount + discount) - vatAmount) : (amount - vatAmount)

        return sum + (final);
    }, 0);

    const totalItemDiscount = rows.reduce((sum, row) => { return sum + Number(row?.discount || 0); }, 0);

    useEffect(() => {
        getItems();
    }, [GrnItemData]);

    useEffect(() => {
        const grossAmount = rows.reduce(
            (sum, row) => sum + Number(row?.amount - row?.vatAmount || 0),
            0
        );

        const totalQty = POActualQty?.reduce(
            (sum, row) => sum + Number(row?.qty || 0),
            0
        );
        const qty = rows.reduce(
            (sum, row) => sum + Number(row?.qty || 0),
            0
        );
        const overallamount = POActualQty?.reduce(
            (sum, row) => sum + Number(row?.qty * row?.unitPrice),
            0
        );
        
        const vat = 10;
        // Overall discount amount
        const discountam = (overallamount * overallDiscount) / 100;
        const discountPerQty = totalQty > 0 ? discountam / totalQty : 0;
        const discountAmt = overallDiscount === 0 ? totalItemDiscount : (qty * discountPerQty);

        // Discount per qty

        // Amount after discount
        const amountAfterDiscount = calculatedTotal - discountAmt;

        // VAT
        // const vatAmount = (amountAfterDiscount * vat) / 100;

        // const vatAmount = rows.reduce((sum, row) => sum + (Number(row?.vatAmount) || 0), 0);
        // Grand Total
        let vatAmount = 0;
        
        if (rows.length === 1) {
            
            const vatRate = rows[0]?.vat;
            vatAmount = (amountAfterDiscount * vatRate) / 100;
        } else {
            // Get unique VAT rates
            const uniqueVatRates = [
                ...new Set(rows.map((r) => Number(r?.vat || 0))),
            ];

            if (uniqueVatRates.length === 1) {
                // Same VAT on all rows
                const vatRate = uniqueVatRates[0];
                vatAmount = (amountAfterDiscount * vatRate) / 100;
            } else {
                // Different VAT rates
                vatAmount = rows.reduce(
                    (sum, row) => sum + Number(row?.vatAmount || 0),
                    0
                );
            }
        }
        const grandTotal = amountAfterDiscount + vatAmount;


        // Optional: update rows with per qty discount
        const updatedRows = rows.map((row) => ({
            ...row,
            discountPerQty,
        }));

        // Only if you want to save it in state
        // setRows(updatedRows);

        setDiscountAmount(discountAmt);
        setOverallDiscountAmount(discountam);
        setVatAmount(vatAmount);
        setGrandTotal(grandTotal);

        // If you need discountPerQty elsewhere
        // setDiscountPerQty(discountPerQty);

    }, [rows, overallDiscount, totalItemDiscount]);

    const getItems = async () => {
        try {

            const apiService = new ApiService();
            let param = `?id=${SelectedPO?.label}`;
            const PO = await apiService.getApiParamater('GET_PO', param);
            const filterered = GrnItemData?.filter((itm) => itm?.qty > 0)
            setPOactualQty(PO?.data?.result[0]?.poDetails)
            
            const formattedRowsitm = filterered?.map(async (detail, index) => {
                const selecteditem = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                
                return {
                    srno: detail?.srno,
                    grnNo: detail.grnNo,
                    ItemNo: detail.itemCode,
                    itemDescription: detail.itemDescription,
                    qty: detail.qty,
                    uom: detail.uom,
                    baseAmount: detail.price,
                    specification: detail.specification,
                    unitPrice: detail.unitPrice,
                    amount: detail.amount,
                    stock: detail?.convToInvUOM * detail.qty,
                    vat: detail.vatPerc,
                    discount: detail?.discount?.toFixed(currencyPrecision || 3) || 0,
                    vatAmount: detail?.vatAmount,
                    calculatedTotal: (detail?.qty * detail?.unitPrice) - detail?.discount,
                    inventoryAccountCode: selecteditem?.data?.result[0]?.invoiceAccountCode,
                    inventoryAccountName: selecteditem?.data?.result[0]?.invoiceAccountName,
                };
            }).filter(row => row !== null);
            const formattedRows = await Promise.all(formattedRowsitm);
            if (formattedRows.length > 0) {
                setRows(formattedRows);
                onRequisitionData(formattedRows);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    return (
        <div className='table-container p-2 ' style={{ overflowX: 'auto', height: "auto" }}>
            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Discount %</label>
                    <input
                        type="number"
                        className="form-control"
                        value={overallDiscount}
                        disabled
                    />
                </div>
                <div className="col-md-4">
                    <label>Discount Amount</label>
                    <input
                        type="number"
                        className="form-control"
                        value={overallDiscountAmount}
                        disabled
                    />
                </div>
            </div>
            <table>
                <thead className='dynoTable'>
                    <tr>
                        <th>Sr no</th>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Item Specs</th>
                        <th>Qty</th>
                        <th>Packing UOM</th>
                        <th>Inventory Qty</th>
                        <th>Unit Price</th>
                        <th>Discount</th>
                        <th>Calculated Amount</th>
                        <th>VAT %</th>
                        <th>VAT Amount</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(rows) && rows.map((row, index) => (
                        <tr key={index}>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={index + 1} style={{ width: "80px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.ItemNo} style={{ width: "100px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.itemDescription} style={{ width: "150px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.specification} style={{ width: "150px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.qty} style={{ width: "80px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.uom} style={{ width: "140px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.stock} style={{ width: "140px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row?.unitPrice || 0).toFixed(4)} style={{ width: "100px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.discount} style={{ width: "100px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row?.calculatedTotal || 0).toFixed(currencyPrecision || 0)} style={{ width: "100%" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.vat + " %"} style={{ width: "100px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} style={{ width: "135px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row?.amount || 0).toFixed(currencyPrecision || 0)} style={{ width: "100px" }} /></td>
                        </tr>
                    ))
                    }
                </tbody>
            </table>
            <div className="d-flex justify-content-between boxs">
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Amount</div>
                    <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">_</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Discount</div>
                    <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">After Discount</div>
                    <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">+</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Vat</div>
                    <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Net Amount</div>
                    <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceViewItemList;